import * as React from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useGetEmailTemplatesQuery } from "../../services/email-template.service";
import { useTitle } from "../../hooks/useTitle";
import StickyBox from "react-sticky-box";
import EmailTemplateEditPage from "./EmailTemplateEditPage";
import { EmailTemplate } from "../../types/emailTemplate";
import { CardBase, OrangeLinearProgress } from "../../components/global";

const EmailTemplatesPage = () => {
  useTitle("Email Templates");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [currentData, setCurrentData] = React.useState<EmailTemplate | null>(
    null
  );

  const { data, isLoading } = useGetEmailTemplatesQuery();

  const sorted = React.useMemo(() => {
    return data?.slice().sort((a, b) => (a.key > b.key ? 1 : -1));
  }, [data]);

  React.useEffect(() => {
    if (!!sorted && sorted?.length > 0 && !currentData) {
      setCurrentData(sorted[0]);
    }
  }, [currentData, sorted]);

  return (
    <Box>
      {isLoading && <OrangeLinearProgress />}
      <Grid container spacing={2}>
        <Grid item lg={3} md={4} xs={12}>
          <StickyBox offsetTop={isMobile ? 60 : 70} offsetBottom={20}>
            <CardBase
              title="Templates"
              useGlassCard={false}
              sx={{ mb: 2 }}
            >
              <List sx={{ p: 0 }}>
                {sorted?.map((row) => (
                  <ListItem key={row.key} dense disablePadding>
                    <ListItemButton
                      onClick={() => setCurrentData(row)}
                      selected={currentData?.key === row.key}
                      sx={{
                        borderRadius: 1,
                        mx: 1,
                        mb: 0.5,
                        transition: "all 0.2s ease",
                        "&:hover": {
                          backgroundColor: "rgba(244, 162, 89, 0.08)",
                          transform: "translateX(4px)",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "rgba(244, 162, 89, 0.12)",
                          color: "#F4A259",
                          fontWeight: 600,
                          "&:hover": {
                            backgroundColor: "rgba(244, 162, 89, 0.16)",
                          },
                        },
                      }}
                    >
                      <ListItemText
                        primary={row.title}
                        primaryTypographyProps={{
                          fontSize: { xs: "0.875rem", sm: "0.9rem" },
                          fontWeight: currentData?.key === row.key ? 600 : 400,
                        }}
                        sx={{
                          color: !row.template ? "#d32f2f" : "inherit",
                          "& .MuiListItemText-primary": {
                            color: currentData?.key === row.key
                              ? "#F4A259"
                              : (!row.template ? "#d32f2f" : "inherit"),
                          },
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </CardBase>
          </StickyBox>
        </Grid>
        <Grid item lg={9} md={8} xs={12}>
          <EmailTemplateEditPage data={currentData} />
        </Grid>
      </Grid>
    </Box>
  );
};
export default EmailTemplatesPage;
